import { useMediaQuery, Theme } from '@mui/material';
import { Breakpoint } from '@mui/material/styles';


export const useBreakpoint = (): Record<Breakpoint, boolean> => {
  const xs = useMediaQuery<Theme>(theme => theme.breakpoints.up('xs'));
  const sm = useMediaQuery<Theme>(theme => theme.breakpoints.up('sm'));
  const md = useMediaQuery<Theme>(theme => theme.breakpoints.up('md'));
  const lg = useMediaQuery<Theme>(theme => theme.breakpoints.up('lg'));
  const xl = useMediaQuery<Theme>(theme => theme.breakpoints.up('xl'));

  return {
    xs,
    sm,
    md,
    lg,
    xl,
  };
};
